/* eslint-disable consistent-return */
import { isArray } from 'util';
import { isProfane } from './profanity';

export const isEmpty = value => value === undefined || value === null || value === '';
const join = (rules) => (value, data) => rules.map(rule => rule(value, data)).filter(error => !!error)[0];

export function email(value) {
    // Let's not start a debate on email regex. This is just for an example app!
    if (!isEmpty(value) && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,20}$/i.test(value)) {
        return 'This does not appear to be a valid email';
    }
}

export function requiredEmail(value) {
    let error = email(value);
    if (isEmpty(value)) {
        error = 'This field is required.';
    }
    return error;
}

export function phoneNumber(value) {
    if (!isEmpty(value) && !/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(value)) {
        return 'Please provide a valid phone number. Country codes (\'+1\') are not required.';
    }
}

export function zipCode(value) {
    if (!isEmpty(value) && !/^\d{5}(?:[-\s]\d{4})?$/.test(value)) {
        return 'Please provide a valid zip code.';
    }
}

export function checkBoxSelected(value) {
    if (isEmpty(value) || value === false) {
        return 'This field is required';
    }
}

export function required(value) {
    if (isEmpty(value)) {
        return 'This field is required';
    }
}

export function minLength(min) {
    return value => {
        if (!isEmpty(value) && value.length < min) {
            return `Must be at least ${min} characters`;
        }
    };
}

export function maxLength(max) {
    return value => {
        if (!isEmpty(value) && value.length > max) {
            return `Must be no more than ${max} characters`;
        }
    };
}

export function integer(value) {
    if (!isEmpty(value) && !Number.isInteger(Number(value))) {
        return 'Must be an integer';
    }
}

export function range(min, max) {
    return value => {
        if (!isEmpty(value) && (value < min)) {
            return `Value can't be less than ${min}`;
        }
        if (!isEmpty(value) && (value > max)) {
            return `Value can't be greater than ${max}`;
        }
    };
}


export function oneOf(enumeration) {
    return value => {
        // eslint-disable-next-line no-bitwise
        if (!~enumeration.indexOf(value)) {
            return `Must be one of: ${enumeration.join(', ')}`;
        }
    };
}

export function match(field) {
    return (value, data) => {
        if (data) {
            if (value !== data[field]) {
                return 'Do not match';
            }
        }
    };
}

export function password(value) {
    if (!isEmpty(value) && !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d!$%&@#^ *?&]{8,}$/.test(value)) {
        return 'Password does not meet complexity requirements';
    }
}
export function requiredPassword(value) {
    let error = password(value);
    if (isEmpty(value)) {
        error = 'This field is required.';
    }
    return error;
}

export function checkProfanity(value, words) {
    if (isProfane(value, words)) {
        return 'Please use clean language for the benefit of the UTR community.';
    }
}

export function createValidator(rules) {
    return (data = {}) => {
        const errors = {};
        Object.keys(rules).forEach((key) => {
            const rule = join([].concat(rules[key])); // concat enables both functions and arrays of functions
            const error = rule(data[key], data);
            if (error) {
                errors[key] = error;
            }
        });
        return errors;
    };
}

export function createReactFormValidator(fn) {
    return (value) => {
        if (!isArray(fn)) {
            // eslint-disable-next-line no-param-reassign
            fn = [fn];
        }
        let error;
        fn.forEach(validator => {
            const resp = validator(value);
            if (!isEmpty(resp)) {
                error = resp;
                return false;
            }
        });
        return { error };
    };
}
